export const mapKeysToValue = <T extends unknown>(
  keys: string[],
  value: T,
): { [key: string]: T } =>
  keys.reduce(
    (acc, key) => ({
      ...acc,
      [key]: value,
    }),
    {},
  );

const haveSameKeysAndValuesSingle = <T extends object>(
  obj1: T,
  obj2: T,
): boolean => {
  const obj1Entries = Object.entries(obj1);
  const obj2Entries = Object.entries(obj2);

  return (
    obj1Entries.length === obj2Entries.length &&
    !!obj1Entries.reduce((acc: boolean | undefined, [obj1Key, obj1Value]) => {
      if (acc === false) return false;

      return !!obj2Entries.find(
        ([obj2Key, obj2Value]) =>
          obj1Key === obj2Key && obj1Value === obj2Value,
      );
    }, undefined)
  );
};

const haveSameKeysAndValuesMultiple = <T extends object>(
  objects: T[],
): boolean => {
  const firstObject = objects[0];

  return objects
    .slice(1)
    .every((obj) => haveSameKeysAndValuesSingle(firstObject, obj));
};

/**
 * A simple equality check for objects that will NOT check for deep equality,
 * such as objects having values that are also objects or multidimensional
 * arrays
 * TODO Add deep equality function, when needed
 * */
export const objectsAreEqual = <T extends object>(...objects: T[]): boolean =>
  haveSameKeysAndValuesMultiple(Array.from(objects));
